import ListTable from './ListTable';

export default ListTable;
